const ROLE = {
  CALL_CENTER_QA: 'Call Center QA',
  CALL_CENTER_SUPERVISOR: 'Call Center Supervisor',
  CALL_CENTER_QA_LEADER: 'Call Center QA Leader',
  CALL_CENTER_TECHNICIAN: 'Call Center Technician',
  CALL_CENTER_TECHNICIAN_LEADER: 'Call Center Technician Leader',
};

const LIST_ROLES_CALL_CENTER = [
  'Call Center Supervisor',
  'Call Center QA Leader',
  'Call Center Technician',
  'Call Center Technician Leader',
  'Call Center QA',
];

export { LIST_ROLES_CALL_CENTER, ROLE };
